module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp2_5012.4600329d.png";